<template>
  <div class="hkfc-match__wrapper has-space">
    <div>
      <div class="hkfc-match__container">
        <div
          class="hkfc-live-video__wrapper"
          :class="{ 'show-login': status === 'showLogin' }"
        >
          <!-- countdown -->
          <div
            v-if="status === 'showCountdown'"
            class="hkfc-countdown__wrapper"
          >
            <div class="hkfc-countdown">
              <div class="hkfc-countdown__card-container">
                <div class="hkfc-countdown__card">
                  <div class="hkfc-countdown__number">{{ countdown.days }}</div>
                  <div class="hkfc-countdown__day">{{ $t("DAYS") }}</div>
                </div>
                <div>:</div>
              </div>
              <div class="hkfc-countdown__card-container">
                <div class="hkfc-countdown__card">
                  <div class="hkfc-countdown__number">{{ countdown.hrs }}</div>
                  <div class="hkfc-countdown__day">
                    {{ isMobile ? $t("HRS") : $t("HOURS") }}
                  </div>
                </div>
                <div>:</div>
              </div>
              <div class="hkfc-countdown__card-container">
                <div class="hkfc-countdown__card">
                  <div class="hkfc-countdown__number">{{ countdown.min }}</div>
                  <div class="hkfc-countdown__day">
                    {{ isMobile ? $t("MINS") : $t("MINUTES") }}
                  </div>
                </div>
                <div>:</div>
              </div>
              <div class="hkfc-countdown__card-container last">
                <div class="hkfc-countdown__card last">
                  <div class="hkfc-countdown__number">{{ countdown.sec }}</div>
                  <div class="hkfc-countdown__day">
                    {{ isMobile ? $t("SECS") : $t("SECONDS") }}
                  </div>
                </div>
              </div>
            </div>
            <!--  h-100 img-cover -->
            <img
              class="w-100"
              src="../../../static/images/sgfc/countdown-bg.png"
            />
          </div>
          <!-- login -->
          <div
            v-if="status === 'showLogin'"
            class="match-detail__video-live-overlay"
          >
            <div class="match-detail__video-live-overlay__title">
              {{ $t("MATCH_DETAIL_TO_SIGN_IN_VIEW_LIVE_VIDEO") }}
            </div>
            <div class="match-detail__video-live-overlay__button-wrapper">
              <router-link
                :to="{
                  name: 'signup',
                  query: { callBackUrl: currentPathName },
                }"
              >
                <button class="btn w-100 mb-1rem btn-aspn-primary">
                  {{ $t("JOIN_NOW") }}
                </button>
              </router-link>
              <router-link
                :to="{
                  name: 'signin',
                  query: { callBackUrl: currentPathName },
                }"
              >
                <button class="btn btn-outline-white w-100">
                  {{ $t("SIGN_IN") }}
                </button>
              </router-link>
            </div>
          </div>
          <!-- banner -->
          <div v-if="status === 'showBanner'" class="w-100 h-100">
            <img
              class="w-100 h-100"
              src="../../../static/images/hkfc/no-live-video-bg.png"
            />
          </div>
          <!-- video -->
          <div v-show="status === 'showVideo'" class="w-100 h-100 relative">
            <img
              class="hkfc-live-icon"
              src="../../../static/images/icons/icon_livevideo.png"
            />
            <iframe
              class="w-100 h-100"
              :src="liveVideo"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <div class="hkfc-date__wrapper">
          <div
            class="hkfc-date__card"
            :class="{ selected: o.selected }"
            v-for="(o, index) in dates"
            :key="index"
            @click="selectDate(o)"
          >
            <div class="hkfc-date__title">{{ $t(o.day) }}</div>
            <div>{{ o.date }}{{ addCNCalendarDay }} {{ $t(o.month) }}</div>
          </div>
        </div>
        <div v-if="!isLoading && !isShowNoData">
          <div
            class="match-wrapper"
            v-for="(o, index) in matchList"
            :key="index"
          >
            <!-- <div v-if="isMobile" class="hkfc-match__header">
            <img
              class="mr-05rem icon-league"
              src="../../../static/images/icons/icon-hkfc.png"
            />
            <div>
              <p>{{ o.leagueName }}</p>
              <p class="hkfc-match__header-country">{{ o.country }}</p>
            </div>
          </div> -->
            <!-- v-else -->
            <div class="display-flex-align-center home-match__title-wrapper">
              <div class="home-match__title"></div>
              <img
                class="mr-05rem icon-league"
                src="../../../static/images/icons/icon-hkfc.png"
              />

              <div class="home-match__title">
                <div class="home-match-country">
                  {{ o.country }}
                </div>
                <span v-if="o.leagueName !== null">{{ o.leagueName }}</span>
                <span v-if="!!o.subLeagueName">: {{ o.subLeagueName }}</span>
                <span class="league-fav-icon">
                  <FavStarIcon v-if="o.isFavLeague" />
                </span>
                <!-- <span class="home-match__title" v-if="o.leagueName !== null"
                >|</span
              >
              <div class="home-match__title" v-if="o.leagueName !== null">
                {{ o.leagueName }}
              </div>
              <div
                v-if="o.isFavLeague"
                class="icon-fav small"
                :class="{ 'has-subleague-fav': !!o.subLeagueName }"
              ></div>
              <div class="home-match__title" v-if="!!o.subLeagueName">
                : {{ o.subLeagueName }}
              </div> -->
              </div>
            </div>

            <router-link
              :to="{ path: formatMatchUrl(o, level2) }"
              target="_blank"
              class="match-container"
              v-for="(level2, index) in o.matchList"
              :key="index"
            >
              <div
                class="home-match__score-card__wrapper flex-col"
                :class="{ 'live-selected': level2.isLive }"
              >
                <!-- <div class="home-match__league-group">
                {{ level2.grouped ? level2.grouped : level2.roundEn }}
              </div> -->

                <div class="home-match__1-wrapper 12">
                  <div
                    class="display-flex-sb home-match__1-container"
                    :key="index"
                  >
                    <!-- <div class="display-flex-sb flex-1 h-100"> -->
                    <div class="home-match__status">
                      <span
                        v-show="type === 'team' && level2.matchState !== 0"
                        v-html="statusWithoutComma(level2.matchStatus)"
                      ></span>
                      <span
                        v-show="type !== 'team' && level2.matchState !== 0"
                        >{{ statusWithoutComma(level2.matchStatus) }}</span
                      >
                    </div>
                    <div class="match-detail">
                      <div class="match-detail__team-container">
                        <div class="icon-league">
                          <span
                            class="penalty-compact-label right"
                            v-if="level2.opponents[0].penaltyWin"
                            >P</span
                          >
                          <img
                            :src="`${s3ImgUrl}/${level2.opponents[0].logo}`"
                          />
                          <span class="team-fav-icon-right">
                            <FavStarIcon
                              v-if="level2.opponents[0].isFavTeam"
                              starType="small"
                            />
                          </span>
                        </div>
                        <div class="match-detail__name">
                          {{ level2.opponents[0].name }}
                        </div>
                      </div>
                    </div>
                    <!-- </div> -->

                    <div class="match-score-or-time-section">
                      <div
                        v-if="
                          level2.matchState !== 0 &&
                          !['Postp.', 'TBA'].includes(level2.matchStatus)
                        "
                        :class="[
                          level2.opponents[0].redCard < 1 &&
                          level2.opponents[1].redCard < 1
                            ? 'match-score-or-time__pad-for-red-card'
                            : 'team-red-card-section',
                        ]"
                      >
                        <div class="team-red-card-container">
                          <template v-if="level2.opponents[0].redCard >= 3">
                            <div class="team-red-card-container">
                              <div
                                class="team-red-card"
                                v-for="card in 3"
                                :key="card"
                              ></div>
                            </div>
                          </template>
                          <template v-else-if="level2.opponents[0].redCard < 3">
                            <div class="team-red-card-container">
                              <div
                                class="team-red-card"
                                v-for="card in level2.opponents[0].redCard"
                                :key="card"
                              ></div>
                            </div>
                          </template>
                        </div>
                        <div class="team-red-card-container">
                          <template v-if="level2.opponents[1].redCard >= 3">
                            <div class="team-red-card-container">
                              <div
                                class="team-red-card"
                                v-for="card in 3"
                                :key="card"
                              ></div>
                            </div>
                          </template>
                          <template v-else-if="level2.opponents[1].redCard < 3">
                            <div class="team-red-card-container">
                              <div
                                class="team-red-card"
                                v-for="card in level2.opponents[1].redCard"
                                :key="card"
                              ></div>
                            </div>
                          </template>
                        </div>
                      </div>

                      <div
                        v-if="['Postp.', 'TBA'].includes(level2.matchStatus)"
                        class="match-score-or-time-container match-score-or-time__pad-for-red-card"
                      >
                        <div class="match-score-or-time__strikethrough">
                          {{ level2.matchTime }}
                        </div>
                      </div>
                      <div
                        v-else-if="level2.matchState !== 0"
                        class="match-score-or-time-container"
                      >
                        <div class="match-detail__score home-match__icon-team">
                          {{ level2.opponents[0].score }}
                        </div>
                        <div class="match-middle__seperator">-</div>
                        <div class="home-match__icon-team match-detail__score">
                          {{ level2.opponents[1].score }}
                        </div>
                      </div>
                      <div
                        class="match-score-or-time-container match-score-or-time__pad-for-red-card"
                        v-else
                      >
                        {{ level2.matchStatus }}
                      </div>

                      <template
                        v-if="
                          level2.opponents[0].penaltyScore !== null &&
                          level2.opponents[1].penaltyScore !== null
                        "
                      >
                        <div class="match-penalty-score-wrapper">
                          PEN:
                          {{ level2.opponents[0].penaltyScore
                          }}<span class="match-penalty-score-separator">-</span
                          >{{ level2.opponents[1].penaltyScore }}
                        </div>
                      </template>
                    </div>

                    <!-- <div class="display-flex-sb flex-1 h-100"> -->
                    <div class="match-detail">
                      <div class="match-detail__team-container">
                        <div class="icon-league">
                          <span
                            class="penalty-compact-label left"
                            v-if="level2.opponents[1].penaltyWin"
                            >P</span
                          >
                          <span class="team-fav-icon-left">
                            <FavStarIcon
                              v-if="level2.opponents[1].isFavTeam"
                              starType="small"
                            />
                          </span>
                          <img
                            :src="`${s3ImgUrl}/${level2.opponents[1].logo}`"
                          />
                        </div>
                        <div class="match-detail__name">
                          {{ level2.opponents[1].name }}
                        </div>
                      </div>
                    </div>
                    <div class="btn-fav-wrapper">
                      <!-- <div
                      v-if="isLogin"
                      @click="handleFavMatchClick(o, level2, $event)"
                      class="btn-fav-aspn match-list-fav"
                      :class="[favMatchClassObj(level2)]"
                    ></div> -->
                    </div>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <div class="home-match__actions-card__wrapper"></div>
            </router-link>
          </div>
        </div>

        <div
          v-else-if="isLoading && !isShowNoData"
          class="skeleton-match__wrapper"
        >
          <div class="mb-2rem">
            <div class="skeleton-child skeleton-match__title"></div>
            <div class="skeleton-child skeleton-match__content"></div>
            <div class="skeleton-child skeleton-match__content"></div>
          </div>

          <div class="mb-2rem">
            <div class="skeleton-child skeleton-match__title"></div>
            <div class="skeleton-child skeleton-match__content"></div>
          </div>

          <div class="mb-2rem">
            <div class="skeleton-child skeleton-match__title"></div>
            <div class="skeleton-child skeleton-match__content"></div>
            <div class="skeleton-child skeleton-match__content"></div>
          </div>

          <div class="mb-2rem">
            <div class="skeleton-child skeleton-match__title"></div>
            <div class="skeleton-child skeleton-match__content"></div>
          </div>

          <div class="mb-2rem">
            <div class="skeleton-child skeleton-match__title"></div>
            <div class="skeleton-child skeleton-match__content"></div>
            <div class="skeleton-child skeleton-match__content"></div>
          </div>

          <div class="mb-2rem">
            <div class="skeleton-child skeleton-match__title"></div>
            <div class="skeleton-child skeleton-match__content"></div>
            <div class="skeleton-child skeleton-match__content"></div>
          </div>
        </div>

        <div v-else-if="!isLoading && isShowNoData" class="no-data mb-2rem">
          {{ $t("NO_MATCHES") }}
        </div>
      </div>
    </div>
    <div v-if="!isMobile" class="flex-1">
      <Standing></Standing>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import config from "@/js/config.js";
import Standing from "../sgfc/Standing.vue";
import FavStarIcon from "@/components/indicator/FavStarIcon.vue";
import moment from "moment";
export default {
  components: {
    Standing,
    FavStarIcon,
  },
  data() {
    return {
      s3ImgUrl: config.s3ImgUrl,
      cnLocaleList: config.cnLocaleList,
      status: "showCountdown",
      liveVideo: null,
      matchList: [],
      isLoading: false,

      intervalCountdown: null,
      countdown: {
        days: "00",
        hrs: "00",
        min: "00",
        sec: "00",
      },
      dates: [
        // {
        //     day: "FRI",
        //     fullDate: "2023/05/26 00:00:00 GMT+0800",
        //     date: "26",
        //     month: "MAY",
        //     value: "2023-05-26",
        //     selected: false
        // },
        // {
        //     day: "SAT",
        //     fullDate: "2023/05/27 00:00:00 GMT+0800",
        //     date: "27",
        //     value: "2023-05-27",
        //     month: "MAY",
        //     selected: false
        // },
        // {
        //     day: "SUN",
        //     fullDate: "2023/05/28 00:00:00 GMT+0800",
        //     date: "28",
        //     value: "2023-05-28",
        //     month: "MAY",
        //     selected: false
        // }
      ],
      isShowNoData: false,
    };
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "isMobile",
      "currentLocale",
      "currentLanguageObj",
      "currentSportType",
    ]),
    addCNCalendarDay() {
      if (this.cnLocaleList.includes(this.currentLocale)) {
        return "日";
      }
      return;
    },
  },
  watch: {
    isLogin: {
      deep: true,
      handler(current, prev) {
        this.init();
      },
    },
  },
  mounted() {
    this.commonVerifyLogin();
    this.init();
  },
  methods: {
    ...mapActions([
      "getSgfcMatchLiveVideos",
      "getSGFCMatchListAsync2",
      "commonVerifyLogin",

      "getMatchListAsync2",
    ]),
    statusWithoutComma(text) {
      return text.replace(/\.\s*$/gm, "");
    },
    async getSgfcMatchLiveVideosData() {
      const result = await this.getSgfcMatchLiveVideos();
      if (result.result.urls.length === 0) {
        this.status = "showBanner";
      } else {
        let newLiveVideo = result.result.urls[0];

        newLiveVideo = newLiveVideo + "&start=1";
        //newLiveVideo = "https://www.youtube.com/embed/AWyoXftuxW0?start=60&autoplay=1";
        if (newLiveVideo !== this.liveVideo) {
          this.liveVideo = newLiveVideo;
        }

        this.status = "showVideo";
      }
    },
    initDate() {
      const currentDate = moment();
      let startDate = moment("2023/05/26 18:00:00 GMT+0800");
      let endDate = moment("2023/05/28 17:48:00 GMT+0800");

      let startD = startDate.date();
      let endD = endDate.date();

      let diff = endD - startD + 1;
      this.dates = [];
      for (let i = 0; i < diff; i++) {
        let first = startD + i;

        const formatedDate = moment(`2023/05/${first} 18:00:00 GMT+0800`);
        let obj = {
          date: formatedDate.date(),
          day: this.$tools.getDay(formatedDate.day()),
          month: this.$tools.getMonth(formatedDate.month()),
          value: formatedDate.format("YYYY-MM-DD"),
        };

        if (obj.date === currentDate.date()) {
          obj.day = "TODAY";
        }
        this.dates.push(obj);
      }
      // let diff = endDate.diff(startDate, 'days')

      // for (let i=0; i<this.dates.length; i++) {
      //     const formatedDate = moment(this.dates[i].fullDate);

      //     this.dates[i].date = formatedDate.date();
      //     this.dates[i].day = this.$tools.getDay(formatedDate.day());
      //     this.dates[i].month = this.$tools.getMonth(formatedDate.month());
      //     this.dates[i].value = formatedDate.format("YYYY-MM-DD");

      //     if (this.dates[i].date === currentDate.date()) {
      //         this.dates[i].day =  "TODAY";
      //     }
      // }

      if (currentDate.date() <= parseInt(this.dates[0].date)) {
        this.selectDate(this.dates[0]);
      } else if (
        currentDate.date() >= parseInt(this.dates[this.dates.length - 1].date)
      ) {
        this.selectDate(this.dates[this.dates.length - 1]);
      } else {
        let gg = this.dates.filter((x) => x.date == currentDate.date())[0];
        this.selectDate(gg);
      }
    },
    selectDate(o) {
      this.dates.forEach((element) => {
        element.selected = false;
      });
      o.selected = !o.selected;

      this.getMatchListData(o);
    },
    async getMatchListData(o) {
      this.isLoading = true;
      let params = {
        leagueIdList: "",
        matchDate: o.value,
        liveOnly: false,
        timeZone: this.$tools.getCurrentTimeZone(),
      };
      const result = await this.getSGFCMatchListAsync2(params);
      if (result.result) {
        this.matchList = result.result.leagueMatchList;
        this.isShowNoData = false;
      } else {
        this.isShowNoData = true;
      }
      this.isLoading = false;
    },
    isMatchEnded(match) {
      return match.matchState < 0 ? true : false;
    },
    favMatchClassObj(o) {
      // const matchEndedStatus = config.matchEndedStatus;
      let disable = false;
      let selected = o.isFavMatch;

      // @command: if match ended has fav, can unfav, but cannot fav again
      if (this.isLogin && this.isMatchEnded(o) && !o.isFavMatch) {
        disable = true;
      }

      return {
        disable: disable,
        selected: selected,
      };
    },

    initCountDown() {
      const formatNumber = (n) => n.toString().padStart(2, "0");
      const eventTime = moment("2023/05/26 18:00:00 GMT+0800").format("X");

      let currentTime = moment().format("X");
      let diffTime = eventTime - currentTime;
      let duration = moment.duration(diffTime, "seconds");

      if (duration._milliseconds < 0) {
        this.verifyStatus();
        setInterval(() => {
          this.verifyStatus();
        }, 5000);
      }

      let interval = setInterval(() => {
        let currentTime = moment().format("X");
        let diffTime = eventTime - currentTime;
        let duration = moment.duration(diffTime, "seconds");

        if (duration._milliseconds < 0) {
          clearInterval(interval);
          this.verifyStatus();
        } else {
          this.countdown.days = formatNumber(duration.days());
          this.countdown.hrs = formatNumber(duration.hours());
          this.countdown.min = formatNumber(duration.minutes());
          this.countdown.sec = formatNumber(duration.seconds());
        }
      }, 800);
    },

    verifyStatus() {
      if (this.isLogin) {
        this.getSgfcMatchLiveVideosData();
      } else {
        this.status = "showLogin";
      }
    },

    init() {
      this.currentPathName = window.location.pathname;

      this.initDate();
      this.initCountDown();
    },

    formatMatchUrl(o, level2) {
      const defaultTeam = "TBD";

      let homeName = defaultTeam;
      let awayName = defaultTeam;
      let fullName = "";

      if (level2.opponents[0].name) {
        homeName = level2.opponents[0].name.replace(/(\s|\/)/g, "-");
      }
      if (level2.opponents[1].name) {
        awayName = level2.opponents[1].name.replace(/(\s|\/)/g, "-");
      }

      fullName = `${homeName}-vs-${awayName}`;

      let path = `/${this.currentLocale}/football/${this.currentSportType}/${
        o.countryKey ?? ""
      }/${o.leagueKey ?? ""}/${fullName}/${level2.matchId}`;

      // `/${this.currentLocale}/football/${this.currentSportType}/${
      //   o.countryKey ?? ""
      // }/${o.leagueKey ?? ""}/${fullName}/${level2.matchId}`;

      return path;
    },
  },
};
</script>

<style scoped>
.hkfc-match__wrapper {
  display: flex;
  gap: 24px;
}
.hkfc-match__container {
  width: 576px; /*680px*/

  background: var(--color-background-default-secondary);
  padding: 16px;
  border-radius: 16px;
  margin-bottom: 1.2rem;
  box-sizing: border-box;
}

/* live video */
.hkfc-live-video__wrapper {
  position: relative;
  /* height: 383px; */
  overflow: hidden;
  border-radius: 16px;
  margin-bottom: 12px;
}
.hkfc-live-video__wrapper.show-login {
  height: 306px;
}
.hkfc-countdown__wrapper {
  position: relative;
  /* height: 100%; */
  width: 100%;
}
.hkfc-countdown {
  display: flex;
  width: 100%;
  position: absolute;
  bottom: 2.4rem;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}
.hkfc-countdown__card-container {
  display: flex;
  align-items: center;
  font-size: 22px;
  margin-right: 8px;
}
.hkfc-countdown__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  min-width: 56px;
  height: 56px;
  margin-right: 8px;
  padding: 5px;
}
.hkfc-countdown__card-container.last,
.hkfc-countdown__card.last {
  margin-right: 0;
}
.hkfc-countdown__number {
  font-family: var(--weight-700);
  font-size: 24px;
}
.hkfc-countdown__day {
  font-family: var(--weight-400);
  font-size: 12px;
}
/* date tabs */
.hkfc-date__card {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  border-radius: 8px;
  /* border-top-left-radius: 4px;
  border-top-right-radius: 4px; */
  cursor: pointer;
  color: var(--color-text-default-secondary);
  font-size: 12px;
  margin: 0 2px;
  padding: 10px 0;
  font-weight: 600;
}
.hkfc-date__card:hover,
.hkfc-date__card.selected {
  background: var(--bg-selected);
  color: white;
}
.hkfc-date__wrapper {
  display: flex;
  margin-bottom: 16px;
}
.hkfc-date__title {
  /* font-family: var(--weight-700); */
  margin-bottom: 3px;
}

.match-detail__video-live-overlay {
  background-color: var(--black-600);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  box-sizing: border-box;
}
.match-detail__video-live-overlay__title {
  margin-bottom: 2rem;
  text-align: center;
  color: #ffffff;
}
.match-detail__video-live-overlay__button-wrapper {
  width: 20rem;
}

/* match card*/
.hkfc-match__header {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: var(--weight-700);
  margin-bottom: 8px;
  letter-spacing: 0.64px;
}
.hkfc-match__header-country {
  font-size: 11px;
  font-family: var(--weight-400);
  color: #93a9b4;
}
.hkfc-live-icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.home-match__title-wrapper {
  font-family: var(--weight-700);
}
/* .home-match__title-wrapper:hover .home-match__title {
  color: white;
} */
.skeleton-match__wrapper {
  width: 100%;
  height: 100%;
  padding: 1rem;
  border-radius: 0.5rem;
  box-sizing: border-box;
}

.skeleton-match__title {
  width: 50%;
  height: 1rem;
  margin-bottom: 0.25rem;
}

.skeleton-match__content {
  width: 100%;
  height: 2rem;
  margin-bottom: 0.5rem;
}

.home-match__win-lose {
  background-color: green;
  border-radius: 50%;
  padding: 0.3rem;
  color: white;
  width: 0.75rem;
  border: 0.1rem solid white;
  height: 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.5rem;
}

.home-match__win-lose.W {
  background-color: #5cd66c;
}

.home-match__win-lose.L {
  background-color: #cf283e;
}

.home-match__win-lose.D {
  background-color: #ed9c5a;
}

.home-match__status {
  margin-right: 16px;
  margin-left: 5px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-text-default-secondary);
  text-align: center;
  margin-bottom: 8px;
  font-family: var(--typography-caption-font-family);
  font-size: var(--typography-caption-size-large);
  font-style: normal;
  font-weight: var(--typography-caption-font-weight-strong);
  line-height: normal;
  letter-spacing: 0.2px;
}

.home-match__1-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.home-match__1-container {
  flex: 1;
  justify-content: space-between;
  /* margin-bottom: 0.2rem; */
}
.home-match__team-name {
  color: var(--color-grey-light);
}
.home-match__date {
  margin-bottom: 0.5rem;

  color: var(--color-text-default-default);

  /* Body Strong */
  font-family: var(--typography-body-font-family);
  font-size: var(--typography-body-size-large);
  font-style: normal;
  font-family: var(--weight-700);
  font-weight: var(--weight-700);
  line-height: 140%; /* 22.4px */
  letter-spacing: 0.64px;
}
.match-wrapper {
  background: var(--color-background-default-secondary);
  /* padding: 16px; */
  border-radius: 16px;
  margin-bottom: 1.2rem;
}

.match-container {
  display: flex;
  margin-bottom: 0.5rem;
  position: relative;
}

.match-container:hover .home-match__score-card__wrapper {
  background-color: var(--color-background-default-tertiary-hover);
}

.match-container:hover .home-match__static-card__wrapper {
  background-color: var(--bg-hover);
}

.match-container:hover
  .home-match__actions-card__wrapper
  .home-match__icon-wrapper {
  background-color: var(--bg-hover);
}

.home-match__static-card__wrapper {
  background-color: #35454d;
  padding: 0.5rem 0.25rem 0.2rem;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 6.25rem;
  align-items: center;
}

.home-match__static-card__brief {
  padding: 0.5rem 1.5rem;
}

.home-match__score-card__wrapper {
  display: flex;
  flex-grow: 1;
  background-color: var(--color-theme);
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  width: 35rem;
  padding: 1rem 0 0.5rem;
  border-left: 0.4rem solid transparent;
  border-radius: var(--size-radius-200);
  background: var(--color-background-default-tertiary);
}

.home-match__score-card__wrapper.live-selected {
  position: relative;
}

.home-match__score-card__wrapper.live-selected:after {
  content: "";
  display: block;
  position: absolute;
  left: -7px;
  top: 0;
  width: 5px;
  height: 100%;
  border-radius: 100px 0 0 100px;
  background-color: var(--color-icon-primary-active);
}

.home-match__score-card__wrapper.no-odds-match {
  border-radius: 0.5rem;
}

.home-match__actions-card__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.live-selected {
  border-left: 0.4rem solid var(--color-icon-primary-active);
}

.match-status__live {
  background-color: #cf283e;
  padding: 0.2rem;
  border-radius: 0.3rem;
  font-size: 10.4px;
}

.match-detail {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.match-detail__status {
  width: 1.6rem;
}

.match-detail__status-w-auto {
  width: auto;
}

.match-detail__score-wrapper {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.match-detail__score-wrapper .score {
  min-width: 1.25rem;
  min-height: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.688rem;
  font-family: var(--weight-700);
}

.match-detail__team-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 15px;
}

.match-detail__name {
  width: 9rem;
  white-space: nowrap;
  overflow: hidden;
  color: var(--color-text-default-default);
  text-align: center;
  text-overflow: ellipsis;

  /* Caption */
  font-family: var(--typography-caption-font-family);
  font-size: var(--typography-body-size-small);
  font-style: normal;
  /* font-family: var(--weight-700); */
  line-height: normal;
  letter-spacing: 0.64px;
  margin-top: 0.375rem;
}

.match-middle {
  flex: 0.5;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.match-middle__seperator {
  margin: 0 0.5rem;
  font-family: var(--weight-700);
}

.match-score-or-time-section {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  /* Subheading Strong */
  font-family: var(--typography-heading-font-family);
  font-size: var(--typography-heading-size-extra-small);
  font-style: normal;
  font-family: var(--weight-700);
  line-height: 120%; /* 24px */
  min-width: 97px;
  /* margin-top: 18px; */
  margin-top: -17px;
}
.fav-time-section {
  margin-top: 18px;
}

.match-score-or-time__strikethrough {
  text-decoration: line-through;
}

.match-score-or-time-container {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-text-default-default);
  text-align: center;
  font-size: 24px;
  font-family: var(--weight-600);
}
.match-score-or-time-container-fav {
  margin-top: 7px;
}
.match-score-or-time__pad-for-red-card {
  padding-top: 0.375rem;
}

.match-penalty-score-wrapper {
  color: var(--color-text-default-secondary);
  text-align: center;

  /* Caption Strong */
  font-family: var(--typography-caption-font-family);
  font-size: var(--typography-caption-size-large);
  font-style: normal;
  font-weight: var(--typography-caption-font-weight-strong);
  line-height: normal;
  letter-spacing: 0.2px;
}

.match-penalty-score-separator {
  margin: 0 0.2rem;
}

.has-subleague-fav {
  margin-right: 0.25rem;
}
.penalty-compact-label {
  border-radius: var(--size-radius-100);
  background: var(--color-background-brand-default);
  padding: 2px 4px;
  font-size: 0.813rem;
  font-family: var(--weight-700);
  color: var(--color-tag-active-text);
  position: absolute;
  top: -0.4rem;
  right: -0.6rem;
}
.penalty-score {
  border-left: 1px solid var(--color-grey-40);
}
.home-match__league-group {
  font-size: 9px;
  color: var(--color-grey-light);
  padding-left: 2.5rem;
  margin-bottom: 5.33px;
}
.icon-league {
  position: relative; /*absolute*/
  width: 40px;
  height: 40px;
  /* padding: 2.5px; */
  box-sizing: border-box;
}
.home-match-country {
  color: var(--color-text-default-secondary);
  font-size: 12px;
  line-height: 140%;
  font-family: var(--weight-400);
}

@media (max-width: 400px) {
  .home-match__team-name {
    /* display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical; */
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 9.5rem;
  }
  .home-match__team-name.with-fav-star,
  .home-match__team-name.with-penalty-score {
    max-width: 8.5rem;
  }
  .home-match__team-name.with-fav-star.with-penalty-score,
  .home-match__team-name.with-penalty-score.with-penalty-win {
    max-width: 7.5rem;
  }
  .home-match__team-name.with-fav-star.with-penalty-score.with-penalty-win {
    max-width: 6.5rem;
  }
}

@media (max-width: 320px) {
  .home-match__team-name {
    max-width: 8rem;
  }
  .home-match__team-name.with-fav-star,
  .home-match__team-name.with-penalty-score {
    max-width: 7rem;
  }
  .home-match__team-name.with-fav-star.with-penalty-score,
  .home-match__team-name.with-penalty-score.with-penalty-win {
    max-width: 6rem;
  }
  .home-match__team-name.with-fav-star.with-penalty-score.with-penalty-win {
    max-width: 5rem;
  }
}
@media (max-width: 1200px) {
  /* for test */
  .match-container:hover .home-match__score-card__wrapper {
    background-color: var(--color-theme);
  }
  .hkfc-date__wrapper {
    margin-bottom: 32px;
    padding: 0 1rem;
  }
  .hkfc-live-video__wrapper {
    margin-bottom: 32px;
    /* height: 45vw; */
  }
  .hkfc-live-video__wrapper.show-login {
    height: 45vw;
  }
  .hkfc-countdown__day {
    font-size: 9px;
  }
  .hkfc-countdown__number {
    font-size: 11px;
  }
  .hkfc-countdown__card-container {
    font-size: 11px;
    margin-right: 4px;
  }
  .hkfc-countdown__card {
    min-width: 32px;
    height: 32px;
    margin-right: 4px;
  }
  .hkfc-countdown__card-container.last,
  .hkfc-countdown__card.last {
    margin-right: 0;
  }
  .hkfc-countdown {
    bottom: 13vw;
  }
  .icon-league {
    width: 36px;
    height: 36px;
    /* padding: 2px; */
    box-sizing: border-box;
  }
}
</style>
